var map = {
	"./canvas/blocks/custom/bulletPoints/admin/BlockPanel.vue": 94307,
	"./canvas/blocks/custom/cards/admin/BlockPanel.vue": 37195,
	"./canvas/blocks/custom/contact/admin/BlockPanel.vue": 1036,
	"./canvas/blocks/custom/header/admin/BlockPanel.vue": 39133,
	"./canvas/blocks/custom/partnerSlider/admin/BlockPanel.vue": 54467,
	"./canvas/blocks/custom/partnerSlider/block.js": 95265,
	"./canvas/blocks/custom/spotlight/admin/BlockPanel.vue": 84296,
	"./canvas/blocks/custom/team/admin/BlockPanel.vue": 83109,
	"./canvas/blocks/custom/tripleBlock/admin/BlockPanel.vue": 53893,
	"./canvas/blocks/custom/video/admin/BlockPanel.vue": 72467,
	"./canvas/blocks/custom/video/block.js": 48725,
	"./canvas/blocks/modules/locations/admin/BlockPanel.vue": 36934,
	"./vendor/canvas/canvas/blocks/utils/text/admin/ckEditorConfig.js": 537
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3078;